import { EnhancedPlan } from '@mm/state/interfaces/subscription';
import { centsToDollars } from '@mm/utils';
import {
  BillingPlanDefinition,
  defaultPlanValues,
  PanelPlanTypes,
} from './constants';

const freePlanDetails: BillingPlanDefinition = {
  name: 'Free Plan',
  descriptionText:
    'Facebook Messenger bot basics, list building and audience tools',
  featuresList: [
    { text: 'Customers.ai OmniChat™' },
    { text: 'UNLIMITED CONTACTS' },
    { text: '1,000 Credits' },
    { text: '1 User' },
    { text: 'Coding-free chatbot builder' },
    { text: 'Chatbot templates' },
    { text: 'Audience segmentation' },
    { text: 'Website Chat Widget' },
    { text: 'Comment Guards' },
    { text: 'Email Support' },
  ],
  theme: 'white',
};

type PlanDefaults = {
  price: string;
  sendLimit: string;
  page: string;
  oldPrice: string;
};

export const billingPlanDetails = (
  planType: PanelPlanTypes,
  plan?: EnhancedPlan,
  isAnnualPrice = false,
  november2021Pricing?: boolean,
): BillingPlanDefinition => {
  if (planType === 'free') {
    return freePlanDetails;
  }
  const defaultValues: PlanDefaults = defaultPlanValues[planType];
  const price =
    (plan &&
      centsToDollars(
        isAnnualPrice ? plan.annualUnitAmountInCents : plan.unitAmountInCents,
        !isAnnualPrice,
      )) ||
    defaultValues.price;
  switch (planType) {
    case 'pro':
      return {
        name: 'OPERATOR',
        price: `$${price}/month`,
        descriptionText:
          'Advanced re-engagement/notification tools & SMS features',
        featuresList: [
          { text: '1 User' },
          { text: 'All features in FREE, plus:', isBold: true },
          { text: 'SMS (US & Canada only)' },
          { text: 'Chat Blaster/Drip Campaigns' },
          { text: 'Custom Notifications' },
          { text: 'Remove Customers.ai Branding' },
          { text: 'Unlimited Q&As' },
          { text: 'Business Hours' },
          { text: 'Advanced Website Chat Settings' },
        ],
        theme: 'orange',
      };
    case 'unicorn':
      return {
        name: 'STARTUP',
        price: `$${price}/month`,
        descriptionText: 'FB Ads/Zapier integrations & Analytics',
        featuresList: [
          { text: 'Up to 100 leads / month', isBold: true },
          { text: 'All features in Operator, plus:', isBold: true },
          { text: '1,200 sends' },
          { text: 'Outreach automation' },
          { text: 'Automatically capture leads from anonymous traffic' },
          { text: 'Lead Generation from existing traffic' },
          { text: '100+ data points on every contact' },
        ],
        theme: 'blue',
      };
    case 'team':
      return {
        name: 'AGENCY',
        price: `$${price}/month`,
        descriptionText:
          'For agencies and freelancers running more than 1 Facebook page',
        featuresList: [
          { text: '400 leads / month', isBold: true },
          {
            text: 'Best for brands with 2,000+ visitors / month',
            isBold: true,
          },
          { text: `3,000 sends` },
          { text: 'Everything in Startup' },
          { text: 'Dedicated support' },
        ],
        theme: 'green',
      };
    default:
      return {
        name: '',
        featuresList: [{ text: '' }],
        theme: null,
        descriptionText: '',
      };
  }
};
